module.exports = __webpack_public_path__ + "static/media/400100_01.7939e388.png";